export const SURVEY_SELECTION_ID = "SurveySelectionId";
export const SURVEY_SELECTION_EXPAND_COLLAPSE_ID =
  "SurveySelectionExpandCollapseId";
export const SURVEY_SELECTION_BUTTON_ID = "SurveySelectionButtonId";
